module.exports = __webpack_public_path__ + "static/media/icn-email.1fde9650.svg";